import React from 'react'
import PropTypes from 'prop-types'
import { Grid, Select, MenuItem, FormControl, Box, Typography } from '@material-ui/core'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableFooter from '@material-ui/core/TableRow'
import TablePagination from '@material-ui/core/TablePagination'
import { withStyles } from '@material-ui/core/styles'
import { styles } from '../../classes/Styles'
import CircularProgress from '@material-ui/core/CircularProgress'
import { Link } from 'react-router-dom'
import IconButton from '@material-ui/core/IconButton'
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward'
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward'
import FirstPageIcon from '@material-ui/icons/FirstPage'
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft'
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight'
import LastPageIcon from '@material-ui/icons/LastPage'
import Tooltip from '@material-ui/core/Tooltip'

import { CLASSES_TO_REMOVE} from '../../constants/commons'

import './LibraryComponent.scss'
import './LibraryComponent'
import SearchComponent from './SearchComponent'
import Thumbnail from '../widgets/Thumbnail'

class LibraryComponent extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    isFetching: PropTypes.bool,
    topics: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      subType: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      thumbnail: PropTypes.string
    })),
    topicsCount: PropTypes.number,
    error: PropTypes.object,
    screenWidth: PropTypes.number,
    page: PropTypes.number,
    size: PropTypes.number,
    totalSize: PropTypes.number,
    fetchTopicsWithPage: PropTypes.func,
    entityTypes: PropTypes.arrayOf(PropTypes.string),
    networkLabels: PropTypes.arrayOf(PropTypes.string),
    categorys: PropTypes.arrayOf(PropTypes.string),
    searchResults: PropTypes.array,
    searchResultClear: PropTypes.func,
    loading: PropTypes.bool,
    getSearchData: PropTypes.func
  }

  constructor (props) {
    super(props)

    this.state = {
      page: 0,
      rowsPerPage: 10,
      nameFilter: '',
      typeFilter: 'TYPE',
      nwFilter: 'NETWORK',
      cgFilter: 'CATEGORY',
      entityTypes: null,
      networkLabels: null,
      categorys: null,
      isFetchSearch: false,
      nameSort: false,
      order: 'asc',
      screenWidth: window.innerWidth
    }
    window.addEventListener('resize', this.handleResize)
  }

  componentDidMount () {
    const removeClass = CLASSES_TO_REMOVE.split(',')
    removeClass.map(className => document.body.classList.remove(className))
    document.body.classList.add('libraryBody')
    this.handleResize()
  }

  componentDidUpdate (prevProps) {
    if (prevProps.isFetching !== this.props.isFetching && this.props.isFetching) {
      this.setState({searchText: null})
    }
    if (this.props.entityTypes && !this.state.entityTypes) {
      this.setState({entityTypes: this.props.entityTypes})
    }
    if (this.props.networkLabels && !this.state.networkLabels) {
      this.setState({networkLabels: this.props.networkLabels})
    }
    if (this.props.categorys && !this.state.categorys) {
      this.setState({categorys: this.props.categorys})
    }
  }

  handleResize = () => {
    this.setState({
      screenWidth: window.innerWidth
    })
  }

  nameSorting () {
    if (this.state.nameSort) {
      this.props.fetchTopicsWithPage(0, this.state.rowsPerPage, this.state.typeFilter, this.state.nwFilter, this.state.cgFilter, this.state.nameFilter, 'asc')
    } else {
      this.props.fetchTopicsWithPage(0, this.state.rowsPerPage, this.state.typeFilter, this.state.nwFilter, this.state.cgFilter, this.state.nameFilter, 'desc')
    }
    this.setState((currentState) => ({
      nameSort: !currentState.nameSort,
      order: !currentState.nameSort ? 'desc' : 'asc',
      page: 0
    }))
  }

  handleChangePage = (event, newPage) => {
    this.props.fetchTopicsWithPage(newPage, this.state.rowsPerPage, this.state.typeFilter, this.state.nwFilter, this.state.cgFilter, this.state.nameFilter, this.state.order)
    this.setState({page: newPage})
  }

  handleChangeRowsPerPage = (event) => {
    this.props.fetchTopicsWithPage(0, parseInt(event.target.value, 10), this.state.typeFilter, this.state.nwFilter, this.state.cgFilter, this.state.nameFilter, this.state.order)
    this.setState({page: 0, rowsPerPage: parseInt(event.target.value, 10)})
  }

  handleTypeChange = (event) => {
    this.setState({page: 0, typeFilter: event.target.value})
    let typeSearch = ('TYPE' === event.target.value)?'':event.target.value
    this.props.fetchTopicsWithPage(0, this.state.rowsPerPage, typeSearch, this.state.nwFilter, this.state.cgFilter, this.state.nameFilter, this.state.order)
  }

  handleNwChange = (event) => {
    this.setState({page: 0, nwFilter: event.target.value})
    let nwSearch = ('NETWORK' === event.target.value)?'':event.target.value
    this.props.fetchTopicsWithPage(0, this.state.rowsPerPage, this.state.typeFilter, nwSearch, this.state.cgFilter, this.state.nameFilter, this.state.order)
  }

  handleCategoryChange = (event) => {
    this.setState({page: 0, cgFilter: event.target.value})
    let cgFilter = ('CATEGORY' === event.target.value)?'':event.target.value
    this.props.fetchTopicsWithPage(0, this.state.rowsPerPage, this.state.typeFilter, this.state.nwFilter, cgFilter, this.state.nameFilter, this.state.order)
  }

  handleNameFilter = (value) => {
     this.setState({page: 0, nameFilter: value, isFetchSearch: false})
     this.props.fetchTopicsWithPage(0, this.state.rowsPerPage, this.state.typeFilter, this.state.nwFilter, this.state.cgFilter, value, this.state.order)
  }

  render () {
    const topics = this.props.topics
    const screenWidth = this.state.screenWidth
    const entityTypes = {}
    const categoryTypes = {}
    if (topics) {
      topics.forEach(topic => {
        entityTypes[topic.subType] = topic.subType
        if (topic.metadata) {
          categoryTypes[topic.metadata] = topic.metadata
        }
      })
      categoryTypes['CPG'] = ['CPG']
    }
    const useStyles = makeStyles((theme) => ({
      formControl: {
        margin: theme.spacing(1),
        minWidth: 120
      },
      selectEmpty: {
        marginTop: theme.spacing(2)
      }
    }))
    const StyledTableCell = withStyles(() => ({
      head: {
        background: '#F4F5F6'
      }
    }))(TableCell)

    const thumbnailFormatter = (cell, row) => {
      const style = {
        width: 42,
        height: 42,
        borderRadius: 5,
        boxShadow: '0px 0px 1px 0px #070707'
      }
      const thumbnail = row.entityLocalizationOverride && row.entityLocalizationOverride.length > 0 && row.entityLocalizationOverride[0].entity_override_image ? row.entityLocalizationOverride[0].entity_override_image : cell
      const name = row.entityLocalizationOverride && row.entityLocalizationOverride.length > 0 && row.entityLocalizationOverride[0].display_name ? row.entityLocalizationOverride[0].display_name : row.name
      return (
        <Thumbnail
          entityOverrideImage={(thumbnail && thumbnail.indexOf('http') === -1) ? thumbnail : null}
          thumbnail={(thumbnail && thumbnail.indexOf('http') > -1) ? cell : null}
          name={name}
          imageDivStyle={style}
          noImgTextClass={'libraryNoImgText'}
          noImgClass={'libraryNoImg'}
          divId={`img_${row.id}`}
        />
      )
    }

    const typeHeaderFormat = () => {
      return (<FormControl className={useStyles.formControl}>
        <Select className='librarySelectFilter'
          id='Type'
          value={this.state.typeFilter}
          onChange={(e) => this.handleTypeChange(e)}
          MenuProps={{
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left'
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'left'
            },
            getContentAnchorEl: null
          }}
          >
          <MenuItem value={'TYPE'} key={'TYPE'}>{this.state.typeFilter !== 'TYPE' ? 'All' : 'Type'}</MenuItem>
          { this.state.entityTypes && this.state.entityTypes.map(entityType => {
            return (
              <MenuItem value={entityType} key={entityType}>
                <span></span>
                <span>{entityType}</span>
              </MenuItem>
            )
          })}
        </Select>
      </FormControl>
      )
    }

    const networkHeaderFormat = () => {
      return (<FormControl className={useStyles.formControl}>
        <Select className='librarySelectFilter'
          id='NETWORK'
          value={this.state.nwFilter}
          onChange={(e) => this.handleNwChange(e)}
          MenuProps={{
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left'
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'left'
            },
            getContentAnchorEl: null
          }}
          >
          <MenuItem value={'NETWORK'} key={'NETWORK'}>{this.state.nwFilter !== 'NETWORK' ? 'All' : 'Network'}</MenuItem>
          { this.state.networkLabels && this.state.networkLabels.map(networkLabel => {
            return (
              <MenuItem value={networkLabel} key={networkLabel}>
                <span></span>
                <span>{networkLabel}</span>
              </MenuItem>
            )
          })}
        </Select>
      </FormControl>
      )
    }

    const categoryHeaderFormat = () => {
      return (<FormControl className={useStyles.formControl}>
        <Select className='librarySelectFilter'
          id='CATEGORY'
          value={this.state.cgFilter}
          onChange={(e) => this.handleCategoryChange(e)}
          MenuProps={{
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left'
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'left'
            },
            getContentAnchorEl: null
          }}
          >
          <MenuItem value={'CATEGORY'} key={'CATEGORY'}>{this.state.cgFilter !== 'CATEGORY' ? 'All' : 'Category'}</MenuItem>
          { this.state.categorys && this.state.categorys.map(category => {
            return (
              <MenuItem value={category} key={category}>
                <span></span>
                <span>{category}</span>
              </MenuItem>
            )
          })}
        </Select>
      </FormControl>)
    }

    const setNameFilter = (val) => {
      if (val && val.length!=0) {
        this.setState({nameFilter: val})
      } else {
        if (this.state.nameFilter.length != 0) {
          this.props.fetchTopicsWithPage(0, this.state.rowsPerPage, this.state.typeFilter, this.state.nwFilter, this.state.cgFilter, val)
          this.setState({isFetchSearch: false, nameFilter: val})
        }
      }
    }
    const handleNameSearch = (val) => {
      if (val && val.length!=0) {
        this.setState({isFetchSearch: true, nameFilter: val})
        this.props.fetchTopicsWithPage(0, this.state.rowsPerPage, this.state.typeFilter, this.state.nwFilter, this.state.cgFilter, val)
      } else {
        if (this.state.nameFilter.length != 0) {
          this.setState({isFetchSearch: false, nameFilter: val})
        }
      }
    }

    const handleClearNameSearch = () => {
      this.setState({isFetchSearch: true, nameFilter: ''})
      this.props.fetchTopicsWithPage(0, this.state.rowsPerPage, this.state.typeFilter, this.state.nwFilter, this.state.cgFilter, '')
    }

    const nameFormatter = (cell, row) => {
      let link = `/insights/audience/${row.id}/media`
      const name = row.entityLocalizationOverride && row.entityLocalizationOverride.length > 0 && row.entityLocalizationOverride[0].display_name ? row.entityLocalizationOverride[0].display_name : row.name
      return (
        <Link to={link}>
          <Tooltip title={name.length >= 55 || (screenWidth <= 1350 && name.length >= 40) ? name : ''} placement="top">
            <span className={name.length >= 55 || (screenWidth <= 1350 && name.length >= 40) ? 'libraryLabelEllipses' : ''}>{name}</span>
          </Tooltip>
        </Link>
      )
    }
    const useStyles1 = makeStyles((theme) => ({
      root: {
        flexShrink: 0,
        marginLeft: theme.spacing(2.5)
      }
    }))
   const TablePaginationActions = () => {
      let count = this.props.totalSize
      let rowsPerPage = this.state.rowsPerPage
      const classes = useStyles1()
      const theme = useTheme()
      const handleFirstPageButtonClick = (event) => {
        this.handleChangePage(event, 0)
      }

      const handleBackButtonClick = (event) => {
        this.handleChangePage(event, this.state.page - 1)
      }

      const handleNextButtonClick = (event) => {
        this.handleChangePage(event, this.state.page + 1)
      }

      const handleLastPageButtonClick = (event) => {
        this.handleChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1))
      }
      return (
        <div className={classes.root}>
          <IconButton
            onClick={handleFirstPageButtonClick}
            disabled={this.state.page === 0}
            aria-label="first page"
          >
            {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
          </IconButton>
          <IconButton onClick={handleBackButtonClick} disabled={this.state.page === 0} aria-label="previous page">
            {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
          </IconButton>
          <IconButton
            onClick={handleNextButtonClick}
            disabled={this.state.page >= Math.ceil(count / rowsPerPage) - 1}
            aria-label="next page"
          >
            {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
          </IconButton>
          <IconButton
            onClick={handleLastPageButtonClick}
            disabled={this.state.page >= Math.ceil(count / rowsPerPage) - 1}
            aria-label="last page"
          >
            {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
          </IconButton>
        </div>
      )
    }

    return (
      <div className="rightSide">
        <Grid container>
          <Grid item xs={12} className="header library">
            <ul className="hFirstRow">
              <li className="imgHolder">
                <img alt="" src="/static/images/library_header.svg" className="imgThumb" />
              </li>
              <li>
                <h2 className="title">Library</h2>
              </li>
            </ul>
          </Grid>
          <Grid item xs={12}>
            <SearchComponent
              loading={this.props.loading}
              searchResults={this.props.searchResults}
              getSearchData={handleNameSearch}
              clearSearchData={handleClearNameSearch}
              searchResultClear={this.props.searchResultClear}
              handleNameFilter={this.handleNameFilter}
              filterValue={this.state.isFetchSearch}
              iconFormatter={this.iconFormatter}
              nameFilter={this.state.nameFilter}
              setNameFilter={setNameFilter}
            />
          </Grid>
          <Grid item xs={12} className="custom-padding">
            <TableContainer className='forLibraryHeadStick libraryMinHeight borderBox libraryTableUI libraryWidthControl headerSpaceFix '>
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableCell></StyledTableCell>
                    <StyledTableCell>
                      <Box>
                        <span className='headLibrary' onClick={() => this.nameSorting()}> {this.state.nameSort ? <ArrowDownwardIcon className='sortIcon' /> : <ArrowUpwardIcon className='sortIcon' />} Name </span>

                      </Box>
                    </StyledTableCell>
                    <StyledTableCell>
                      {typeHeaderFormat()}
                    </StyledTableCell>
                    <StyledTableCell>{networkHeaderFormat()}</StyledTableCell>
                    <StyledTableCell>
                      {categoryHeaderFormat()}
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                { !this.props.isFetching && topics && topics.length === 0 &&
                  <TableBody>
                    <Box className="emptyResultWrap">
                      <Typography>Please check your filters to expand results.</Typography>
                    </Box>
                  </TableBody>
                }
                { !this.props.isFetching &&
                <TableBody>
                  {topics && topics
                .map((row) => (
                  <TableRow key={row.id}>
                    <TableCell>{thumbnailFormatter(row.thumbnail, row)}</TableCell>
                    <TableCell style={{maxWidth: 0}}>{nameFormatter(row.name, row)}</TableCell>
                    <TableCell>{row.subType}</TableCell>
                    <TableCell>{(this.state.nwFilter && this.state.nwFilter.length > 0 && this.state.nwFilter !== 'NETWORK') ? this.state.nwFilter : row.networkLabel}</TableCell>
                    <TableCell>{(this.state.cgFilter && this.state.cgFilter.length > 0 && this.state.cgFilter !== 'CATEGORY') ? this.state.cgFilter : row.metadata}</TableCell>
                  </TableRow>
                ))}
                </TableBody>
                }
                {this.props.isFetching &&
                <TableBody>
                  <tr><td>
                    <div className='libraryPageLoadingProgress'>
                      <CircularProgress />
                    </div>
                  </td></tr>
                </TableBody>
                }
              </Table>
            </TableContainer>
            <Table className='tableFooter'>
              <TableBody>
                { (topics && this.props.topicsCount) &&
                <TableFooter>
                  <TablePagination
                    rowsPerPageOptions= {[10, 25, 50, 100]}
                    count={this.props.totalSize}
                    rowsPerPage={this.state.rowsPerPage}
                    page={this.state.page}
                    onChangePage={this.handleChangePage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActions}
                  />
                </TableFooter>
              }
              </TableBody>
            </Table>
          </Grid>

        </Grid>
      </div>

    )
  }
}

export default withStyles(styles)(LibraryComponent)